var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYouTubeGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.4 67.8C85.6 72 82.2 75.2 78 75.8C71.4 76.8 60.4 78 48 78C35.8 78 24.8 76.8 18 75.8C13.8 75.2 10.4 72 9.6 67.8C8.8 63.2 8 56.4 8 48C8 39.6 8.8 32.8 9.6 28.2C10.4 24 13.8 20.8 18 20.2C24.6 19.2 35.6 18 48 18C60.4 18 71.2 19.2 78 20.2C82.2 20.8 85.6 24 86.4 28.2C87.2 32.8 88.2 39.6 88.2 48C88 56.4 87.2 63.2 86.4 67.8Z",
    fill: "#FFBF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 62V34L64 48L40 62Z",
    fill: "#22223B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeGold);
export default __webpack_public_path__ + "static/media/YouTubeGold.b437f9166bdab5be03c7e0080e0bbb97.svg";
export { ForwardRef as ReactComponent };